/* ============================================================
   ORTOPEDIUM THEME — Main JavaScript
   ============================================================ */

/* ===== UTILS ===== */
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

/* ===== CART STATE ===== */
let cart = { items: [], total_price: 0, item_count: 0 };

async function fetchCart() {
  const res = await fetch('/cart.js');
  cart = await res.json();
  updateCartUI();
  return cart;
}

function updateCartUI() {
  const bubble = $('.cart-bubble');
  if (bubble) {
    bubble.textContent = cart.item_count;
    bubble.classList.add('bump');
    setTimeout(() => bubble.classList.remove('bump'), 300);
  }
  renderCartDrawer();
}

function money(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

/* ===== CART DRAWER ===== */
function openCart() {
  const drawer = $('.cart-drawer');
  const overlay = $('.cart-overlay');
  if (drawer) drawer.classList.add('open');
  if (overlay) overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCart() {
  const drawer = $('.cart-drawer');
  const overlay = $('.cart-overlay');
  if (drawer) drawer.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}

function renderCartDrawer() {
  const itemsEl = $('.cart-items');
  const footerEl = $('.cart-footer');
  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = `
      <div class="cart-empty">
        <div class="cart-empty-icon">🛒</div>
        <div class="cart-empty-title">Tu carrito está vacío</div>
        <p>Añade productos para empezar</p>
        <a href="/collections/productos-de-ortopedia" class="btn-terra" style="margin-top:12px;" onclick="closeCart()">Ver catálogo</a>
      </div>`;
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = 'block';

  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <img class="cart-item-img" src="${item.image}" alt="${item.title}" loading="lazy">
      <div class="cart-item-details">
        <div class="cart-item-title">${item.product_title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:12px;color:var(--muted)">${item.variant_title}</div>` : ''}
        <div class="cart-item-price">${money(item.final_price)}</div>
        <div class="cart-item-qty">
          <button class="qty-btn" onclick="updateItem('${item.key}', ${item.quantity - 1})">−</button>
          <span class="qty-val">${item.quantity}</span>
          <button class="qty-btn" onclick="updateItem('${item.key}', ${item.quantity + 1})">+</button>
        </div>
        <button class="cart-item-remove" onclick="removeItem('${item.key}')">Eliminar</button>
      </div>
    </div>
  `).join('');

  const totalEl = $('.cart-total-val');
  if (totalEl) totalEl.textContent = money(cart.total_price);
}

async function addToCart(variantId, quantity = 1, btn = null) {
  if (btn) { btn.disabled = true; btn.textContent = '...'; }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Error');
    await fetchCart();
    if (btn) {
      btn.textContent = '✓ Añadido';
      btn.classList.add('added');
      setTimeout(() => {
        btn.textContent = '+ Añadir';
        btn.classList.remove('added');
        btn.disabled = false;
      }, 2000);
    }
    openCart();
  } catch (e) {
    if (btn) { btn.disabled = false; btn.textContent = '+ Añadir'; }
  }
}

async function updateItem(key, quantity) {
  if (quantity < 1) { removeItem(key); return; }
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  await fetchCart();
}

async function removeItem(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  await fetchCart();
}

/* ===== ADD TO CART BUTTONS ===== */
function bindAddToCartButtons() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId || btn.dataset.addToCart;
    if (!variantId) return;
    await addToCart(parseInt(variantId), 1, btn);
  });
}

/* ===== PRODUCT PAGE ATC ===== */
function bindProductATC() {
  const form = $('.product-atc-form');
  if (!form) return;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const variantId = form.querySelector('[name="id"]').value;
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value || 1);
    const btn = form.querySelector('.btn-atc');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Añadiendo…';
    }
    await addToCart(parseInt(variantId), qty, null);
    if (btn) {
      btn.textContent = '✓ Añadido al carrito';
      btn.classList.add('added');
      setTimeout(() => {
        btn.textContent = 'Añadir al carrito';
        btn.classList.remove('added');
        btn.disabled = false;
      }, 2500);
    }
    openCart();
  });

  // Qty buttons on product page
  const qtyMinus = $('.qty-minus');
  const qtyPlus = $('.qty-plus');
  const qtyInput = form.querySelector('[name="quantity"]');
  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      const v = Math.max(1, parseInt(qtyInput.value) - 1);
      qtyInput.value = v;
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value) + 1;
    });
  }
}

/* ===== VARIANT SELECTOR ===== */
function bindVariantSelector() {
  $$('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.dataset.group;
      $$(`.variant-btn[data-group="${group}"]`).forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      // Update hidden input
      updateSelectedVariant();
    });
  });
}

function updateSelectedVariant() {
  const form = $('.product-atc-form');
  if (!form) return;
  // Simple: take first available variant if single variant
  // For multi-variant, this would need full variant matching logic
}

/* ===== GALLERY ===== */
function bindGallery() {
  $$('.thumb-btn').forEach(thumb => {
    thumb.addEventListener('click', () => {
      $$('.thumb-btn').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = $('.gallery-main img');
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
      }
    });
  });
}

/* ===== SEARCH ===== */
let searchTimeout;

function openSearch() {
  const overlay = $('#searchOverlay');
  if (overlay) {
    overlay.classList.add('open');
    setTimeout(() => $('#searchInput')?.focus(), 80);
    document.body.style.overflow = 'hidden';
  }
}

function closeSearch() {
  const overlay = $('#searchOverlay');
  if (overlay) {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
}

async function searchProducts(query) {
  if (!query || query.length < 2) {
    $('#searchResults').innerHTML = '';
    return;
  }
  try {
    const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`);
    const data = await res.json();
    const products = data.resources?.results?.products || [];
    const el = $('#searchResults');
    if (!el) return;
    if (products.length === 0) { el.innerHTML = '<p style="font-size:14px;color:var(--muted);padding:8px 0">Sin resultados</p>'; return; }
    el.innerHTML = products.map(p => `
      <a class="search-result-item" href="${p.url}">
        <img class="search-result-img" src="${p.featured_image?.url || ''}" alt="${p.title}" loading="lazy">
        <div>
          <div class="search-result-title">${p.title}</div>
          <div class="search-result-price">${money(p.price)}</div>
        </div>
      </a>
    `).join('');
  } catch(e) {}
}

function bindSearch() {
  const openBtn = $$('[data-open-search]');
  openBtn.forEach(btn => btn.addEventListener('click', openSearch));

  const overlay = $('#searchOverlay');
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeSearch();
    });
  }

  const input = $('#searchInput');
  if (input) {
    input.addEventListener('input', (e) => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => searchProducts(e.target.value), 280);
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && input.value.trim()) {
        window.location.href = `/search?q=${encodeURIComponent(input.value.trim())}&type=product`;
      }
    });
  }

  $$('.chip').forEach(chip => {
    chip.addEventListener('click', () => {
      if (input) { input.value = chip.textContent; searchProducts(chip.textContent); }
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeSearch(); closeCart(); }
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); openSearch(); }
  });
}

/* ===== DESKTOP DROPDOWNS (click-based) ===== */
function bindDropdowns() {
  $$('.nav-link[data-dropdown]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const item = link.closest('.nav-item');
      const isOpen = item.classList.contains('open');
      $$('.nav-item.open').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav-item')) {
      $$('.nav-item.open').forEach(i => i.classList.remove('open'));
    }
  });
}

/* ===== MOBILE MENU ===== */
function bindMobileMenu() {
  const toggle = $('.mobile-toggle');
  const nav = $('.mobile-nav');
  const close = $('.mobile-nav-close');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', () => nav.classList.add('open'));
  close?.addEventListener('click', () => nav.classList.remove('open'));
}

/* ===== WISHLIST ===== */
function bindWishlist() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.btn-wish');
    if (!btn) return;
    btn.classList.toggle('active');
    btn.textContent = btn.classList.contains('active') ? '♥' : '♡';
  });
}

/* ===== SCROLL ANIMATIONS ===== */
function bindScrollAnimations() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('visible'), i * 60);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });

  $$('.fade-up').forEach(el => observer.observe(el));
}

/* ===== CART BUTTON IN HEADER ===== */
function bindCartToggle() {
  $$('[data-open-cart]').forEach(btn => {
    btn.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
  });
  const cartOverlay = $('.cart-overlay');
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  const cartClose = $('.cart-close');
  if (cartClose) cartClose.addEventListener('click', closeCart);
}

/* ===== STICKY HEADER ===== */
function bindStickyHeader() {
  const header = $('.site-header');
  if (!header) return;
  let lastY = 0;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (y > 80 && y > lastY) {
      header.style.transform = 'translateY(-100%)';
    } else {
      header.style.transform = 'translateY(0)';
    }
    lastY = y;
  }, { passive: true });
}

/* ===== INIT ===== */
document.addEventListener('DOMContentLoaded', () => {
  fetchCart();
  bindDropdowns();
  bindAddToCartButtons();
  bindProductATC();
  bindVariantSelector();
  bindGallery();
  bindSearch();
  bindMobileMenu();
  bindWishlist();
  bindScrollAnimations();
  bindCartToggle();
  bindStickyHeader();
});
